/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AddressTypeEventDto {
    UNKNOWN = 'Unknown',
    BILLING = 'Billing',
    DELIVERY = 'Delivery',
}
